
define('hbars!bizzabo/templates/editSessionTrack', ['Handlebars'], function (Handlebars) { return Handlebars.compile('<input type="checkbox" name="trackCheckBox{{attributes.index}}"/>\n{{#if attributes.name}}\n    <p>{{attributes.name}}</p>\n{{else}}\n    <p class="empty">Track {{#addOne attributes.index}}{{this}}{{/addOne}}</p>\n{{/if}}'); });

